var App = App || {};

App.Form = (() => {
    'use strict';

    const init = (id) => {
        const form = document.getElementById(id);

        AddFloatingLabels(form);
    }

    const AddFloatingLabels = (form) => {
        const nonTextInput = [
            'button',
            'checkbox',
            'hidden',
            'image',
            'radio',
            'reset',
            'submit'
        ];

        let fields = form.querySelectorAll('.widget-form-field');

        fields.forEach((field) => {
            let input = field.querySelector('.form-control');
            let label = field.querySelector('.control-label');

            if ((input instanceof HTMLInputElement && !nonTextInput.includes(input.getAttribute('type'))) ||
                input instanceof HTMLTextAreaElement ||
                input instanceof HTMLSelectElement) {

                field.classList.add('form-floating');

                label.remove();
                input.after(label);

                if (input.placeholder === '') {
                    input.placeholder = label.textContent;
                }
            }
        });
    }

    return {
        init: init
    };
})();